<template>
    <div class="mt-4">
        <b-form-group
                vertical
                :label-cols="2"
                breakpoint="lg"
                label="General Survey">
            <b-form-textarea v-validate="'required'" data-vv-as="general survey" :rows="3" name="general_survey"
                             v-model="appointment.vital.general_survey"></b-form-textarea>
            <span class="error">{{ errors.first('general_survey') }}</span>
        </b-form-group>

        <p>Vital Signs</p>
        <hr>
        <b-row>
            <b-col lg="6">
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="BP">
                    <b-form-input v-validate="'required'" name="bp" v-model="appointment.vital.bp"></b-form-input>
                    <span class="error">{{ errors.first('bp') }}</span>
                </b-form-group>

                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="HR">
                    <b-form-input v-validate="'required'" name="hr" v-model="appointment.vital.hr"></b-form-input>
                    <span class="error">{{ errors.first('hr') }}</span>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="RR">
                    <b-form-input v-validate="'required'" name="rr" v-model="appointment.vital.rr"></b-form-input>
                    <span class="error">{{ errors.first('rr') }}</span>
                </b-form-group>

                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Temp">
                    <b-form-input v-validate="'required'" name="temp" v-model="appointment.vital.temp"></b-form-input>
                    <span class="error">{{ errors.first('temp') }}</span>
                </b-form-group>
            </b-col>
        </b-row>

        <p>Others</p>
        <hr>
        <b-row>
            <b-col lg="6">
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Head">
                    <b-form-input v-validate="'required'" name="head" v-model="appointment.vital.head"></b-form-input>
                    <span class="error">{{ errors.first('head') }}</span>
                </b-form-group>

                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Temp">
                    <b-form-input v-validate="'required'" name="neck" v-model="appointment.vital.neck"></b-form-input>
                    <span class="error">{{ errors.first('neck') }}</span>

                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Chest/Lungs">
                    <b-form-input v-validate="'required'" name="chest" v-model="appointment.vital.chest"></b-form-input>
                    <span class="error">{{ errors.first('chest') }}</span>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Heart">
                    <b-form-input v-validate="'required'" name="heart" v-model="appointment.vital.heart"></b-form-input>
                    <span class="error">{{ errors.first('heart') }}</span>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Abdomen">
                    <b-form-input v-validate="'required'" name="abdomen"
                                  v-model="appointment.vital.abdomen"></b-form-input>
                    <span class="error">{{ errors.first('abdomen') }}</span>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Back">
                    <b-form-input v-validate="'required'" name="back" v-model="appointment.vital.back"></b-form-input>
                    <span class="error">{{ errors.first('back') }}</span>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Extremities">
                    <b-form-input v-validate="'required'" name="extremities"
                                  v-model="appointment.vital.extremities"></b-form-input>
                    <span class="error">{{ errors.first('extremities') }}</span>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Neuro Exam">
                    <b-form-input v-validate="'required'" name="neuro_exam"
                                  v-model="appointment.vital.neuro_exam"></b-form-input>
                    <span class="error">{{ errors.first('neuro_exam') }}</span>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      appointment: {
        type: Object
      }
    },
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Appointment/Form/Vitals.vue